'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _memoizeOne = require('memoize-one');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _Menu = require('./components/Menu');

var _reactFastCompare = require('./internal/react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _filters = require('./filters');

var _index = require('./internal/index');

var _index2 = require('./accessibility/index');

var _utils = require('./utils');

var _builtins = require('./builtins');

var _index3 = require('./components/index');

var _styles = require('./styles');

var _theme = require('./theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const defaultProps = exports.defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: (0, _utils.isTouchCapable)(),
  captureMenuScroll: !(0, _utils.isTouchCapable)(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: (0, _filters.createFilter)(),
  formatGroupLabel: _builtins.formatGroupLabel,
  getOptionLabel: _builtins.getOptionLabel,
  getOptionValue: _builtins.getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: _builtins.isOptionDisabled,
  loadingMessage: () => 'Loading...',
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !(0, _utils.isMobileDevice)(),
  noOptionsMessage: () => 'No options',
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: ({ count }) => `${count} result${count !== 1 ? 's' : ''} available`,
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

let instanceId = 1;

class Select extends _react.Component {

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // Misc. Instance Properties
  // ------------------------------

  constructor(props) {
    super(props);

    _initialiseProps.call(this);

    const { value } = props;
    this.cacheComponents = (0, _memoizeOne2.default)(this.cacheComponents, _reactFastCompare2.default).bind(this);
    this.cacheComponents(props.components);
    this.instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId);

    const selectValue = (0, _utils.cleanValue)(value);
    const menuOptions = this.buildMenuOptions(props, selectValue);

    this.state.menuOptions = menuOptions;
    this.state.selectValue = selectValue;
  } // TODO

  componentDidMount() {
    this.startListeningComposition();
    this.startListeningToTouch();

    if (this.props.closeMenuOnScroll && document && document.addEventListener) {
      // Listen to all scroll events, and filter them out inside of 'onScroll'
      document.addEventListener('scroll', this.onScroll, true);
    }

    if (this.props.autoFocus) {
      this.focusInput();
    }
  }
  componentWillReceiveProps(nextProps) {
    const { options, value, inputValue } = this.props;
    // re-cache custom components
    this.cacheComponents(nextProps.components);
    // rebuild the menu options
    if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
      const selectValue = (0, _utils.cleanValue)(nextProps.value);
      const menuOptions = this.buildMenuOptions(nextProps, selectValue);
      const focusedValue = this.getNextFocusedValue(selectValue);
      const focusedOption = this.getNextFocusedOption(menuOptions.focusable);
      this.setState({ menuOptions, selectValue, focusedOption, focusedValue });
    }
    // some updates should toggle the state of the input visibility
    if (this.inputIsHiddenAfterUpdate != null) {
      this.setState({
        inputIsHidden: this.inputIsHiddenAfterUpdate
      });
      delete this.inputIsHiddenAfterUpdate;
    }
  }
  componentDidUpdate(prevProps) {
    const { isDisabled, menuIsOpen } = this.props;
    const { isFocused } = this.state;

    if (
    // ensure focus is restored correctly when the control becomes enabled
    isFocused && !isDisabled && prevProps.isDisabled ||
    // ensure focus is on the Input when the menu opens
    isFocused && menuIsOpen && !prevProps.menuIsOpen) {
      this.focusInput();
    }

    // scroll the focused option into view if necessary
    if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
      (0, _utils.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    this.scrollToFocusedOptionOnUpdate = false;
  }
  componentWillUnmount() {
    this.stopListeningComposition();
    this.stopListeningToTouch();
    document.removeEventListener('scroll', this.onScroll, true);
  }

  // ==============================
  // Consumer Handlers
  // ==============================

  onMenuOpen() {
    this.props.onMenuOpen();
  }
  onMenuClose() {
    const { isSearchable, isMulti } = this.props;
    this.announceAriaLiveContext({
      event: 'input',
      context: { isSearchable, isMulti }
    });
    this.onInputChange('', { action: 'menu-close' });
    this.props.onMenuClose();
  }
  onInputChange(newValue, actionMeta) {
    this.props.onInputChange(newValue, actionMeta);
  }

  // ==============================
  // Methods
  // ==============================

  focusInput() {
    if (!this.inputRef) return;
    this.inputRef.focus();
  }
  blurInput() {
    if (!this.inputRef) return;
    this.inputRef.blur();
  }

  // aliased for consumers


  openMenu(focusOption) {
    const { menuOptions, selectValue } = this.state;
    const { isMulti } = this.props;
    let openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

    if (!isMulti) {
      const selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
      if (selectedIndex > -1) {
        openAtIndex = selectedIndex;
      }
    }

    this.scrollToFocusedOptionOnUpdate = true;
    this.inputIsHiddenAfterUpdate = false;

    this.onMenuOpen();
    this.setState({
      focusedValue: null,
      focusedOption: menuOptions.focusable[openAtIndex]
    });

    this.announceAriaLiveContext({ event: 'menu' });
  }
  focusValue(direction) {
    const { isMulti, isSearchable } = this.props;
    const { selectValue, focusedValue } = this.state;

    // Only multiselects support value focusing
    if (!isMulti) return;

    this.setState({
      focusedOption: null
    });

    let focusedIndex = selectValue.indexOf(focusedValue);
    if (!focusedValue) {
      focusedIndex = -1;
      this.announceAriaLiveContext({ event: 'value' });
    }

    const lastIndex = selectValue.length - 1;
    let nextFocus = -1;
    if (!selectValue.length) return;

    switch (direction) {
      case 'previous':
        if (focusedIndex === 0) {
          // don't cycle from the start to the end
          nextFocus = 0;
        } else if (focusedIndex === -1) {
          // if nothing is focused, focus the last value first
          nextFocus = lastIndex;
        } else {
          nextFocus = focusedIndex - 1;
        }
        break;
      case 'next':
        if (focusedIndex > -1 && focusedIndex < lastIndex) {
          nextFocus = focusedIndex + 1;
        }
        break;
    }

    if (nextFocus === -1) {
      this.announceAriaLiveContext({
        event: 'input',
        context: { isSearchable, isMulti }
      });
    }

    this.setState({
      inputIsHidden: nextFocus === -1 ? false : true,
      focusedValue: selectValue[nextFocus]
    });
  }

  focusOption(direction = 'first') {
    const { pageSize } = this.props;
    const { focusedOption, menuOptions } = this.state;
    const options = menuOptions.focusable;

    if (!options.length) return;
    let nextFocus = 0; // handles 'first'
    let focusedIndex = options.indexOf(focusedOption);
    if (!focusedOption) {
      focusedIndex = -1;
      this.announceAriaLiveContext({ event: 'menu' });
    }

    if (direction === 'up') {
      nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
    } else if (direction === 'down') {
      nextFocus = (focusedIndex + 1) % options.length;
    } else if (direction === 'pageup') {
      nextFocus = focusedIndex - pageSize;
      if (nextFocus < 0) nextFocus = 0;
    } else if (direction === 'pagedown') {
      nextFocus = focusedIndex + pageSize;
      if (nextFocus > options.length - 1) nextFocus = options.length - 1;
    } else if (direction === 'last') {
      nextFocus = options.length - 1;
    }
    this.scrollToFocusedOptionOnUpdate = true;
    this.setState({
      focusedOption: options[nextFocus],
      focusedValue: null
    });
  }


  // ==============================
  // Getters
  // ==============================

  getTheme() {
    // Use the default theme if there are no customizations.
    if (!this.props.theme) {
      return _theme.defaultTheme;
    }
    // If the theme prop is a function, assume the function
    // knows how to merge the passed-in default theme with
    // its own modifications.
    if (typeof this.props.theme === 'function') {
      return this.props.theme(_theme.defaultTheme);
    }
    // Otherwise, if a plain theme object was passed in,
    // overlay it with the default theme.
    return _extends({}, _theme.defaultTheme, this.props.theme);
  }

  getCommonProps() {
    const { clearValue, getStyles, setValue, selectOption, props } = this;
    const { classNamePrefix, isMulti, isRtl, options } = props;
    const { selectValue } = this.state;
    const hasValue = this.hasValue();
    const getValue = () => selectValue;
    let cxPrefix = classNamePrefix;

    const cx = _utils.classNames.bind(null, cxPrefix);
    return {
      cx,
      clearValue,
      getStyles,
      getValue,
      hasValue,
      isMulti,
      isRtl,
      options,
      selectOption,
      setValue,
      selectProps: props,
      theme: this.getTheme()
    };
  }

  getNextFocusedValue(nextSelectValue) {
    if (this.clearFocusValueOnUpdate) {
      this.clearFocusValueOnUpdate = false;
      return null;
    }
    const { focusedValue, selectValue: lastSelectValue } = this.state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
      const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
      if (nextFocusedIndex > -1) {
        // the focused value is still in the selectValue, return it
        return focusedValue;
      } else if (lastFocusedIndex < nextSelectValue.length) {
        // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
      }
    }
    return null;
  }

  getNextFocusedOption(options) {
    const { focusedOption: lastFocusedOption } = this.state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
  }

  // ==============================
  // Helpers
  // ==============================


  hasValue() {
    const { selectValue } = this.state;
    return selectValue.length > 0;
  }
  hasOptions() {
    return !!this.state.menuOptions.render.length;
  }
  countOptions() {
    return this.state.menuOptions.focusable.length;
  }
  isClearable() {
    const { isClearable, isMulti } = this.props;

    // single select, by default, IS NOT clearable
    // multi select, by default, IS clearable
    if (isClearable === undefined) return isMulti;

    return isClearable;
  }
  isOptionDisabled(option, selectValue) {
    return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
  }
  isOptionSelected(option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof this.props.isOptionSelected === 'function') {
      return this.props.isOptionSelected(option, selectValue);
    }
    const candidate = this.getOptionValue(option);
    return selectValue.some(i => this.getOptionValue(i) === candidate);
  }
  filterOption(option, inputValue) {
    return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
  }
  formatOptionLabel(data, context) {
    if (typeof this.props.formatOptionLabel === 'function') {
      const { inputValue } = this.props;
      const { selectValue } = this.state;
      return this.props.formatOptionLabel(data, {
        context,
        inputValue,
        selectValue
      });
    } else {
      return this.getOptionLabel(data);
    }
  }
  formatGroupLabel(data) {
    return this.props.formatGroupLabel(data);
  }

  // ==============================
  // Mouse Handlers
  // ==============================

  // ==============================
  // Composition Handlers
  // ==============================

  startListeningComposition() {
    if (document && document.addEventListener) {
      document.addEventListener('compositionstart', this.onCompositionStart, false);
      document.addEventListener('compositionend', this.onCompositionEnd, false);
    }
  }
  stopListeningComposition() {
    if (document && document.removeEventListener) {
      document.removeEventListener('compositionstart', this.onCompositionStart);
      document.removeEventListener('compositionend', this.onCompositionEnd);
    }
  }


  // ==============================
  // Touch Handlers
  // ==============================

  startListeningToTouch() {
    if (document && document.addEventListener) {
      document.addEventListener('touchstart', this.onTouchStart, false);
      document.addEventListener('touchmove', this.onTouchMove, false);
      document.addEventListener('touchend', this.onTouchEnd, false);
    }
  }
  stopListeningToTouch() {
    if (document && document.removeEventListener) {
      document.removeEventListener('touchstart', this.onTouchStart);
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchend', this.onTouchEnd);
    }
  }

  // ==============================
  // Focus Handlers
  // ==============================

  // ==============================
  // Keyboard Handlers
  // ==============================

  // ==============================
  // Menu Options
  // ==============================

  buildMenuOptions(props, selectValue) {
    const { inputValue = '', options } = props;

    const toOption = (option, id) => {
      const isDisabled = this.isOptionDisabled(option, selectValue);
      const isSelected = this.isOptionSelected(option, selectValue);
      const label = this.getOptionLabel(option);
      const value = this.getOptionValue(option);

      if (this.shouldHideSelectedOptions() && isSelected || !this.filterOption({ label, value, data: option }, inputValue)) {
        return;
      }

      const onHover = isDisabled ? undefined : () => this.onOptionHover(option);
      const onSelect = isDisabled ? undefined : () => this.selectOption(option);
      const optionId = `${this.getElementId('option')}-${id}`;

      return {
        innerProps: {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          role: 'option',
          tabIndex: -1
        },
        data: option,
        isDisabled,
        isSelected,
        key: optionId,
        label,
        type: 'option',
        value
      };
    };

    const parseOptions = (acc, item, itemIndex) => {
      if (item.options) {
        const { options: items } = item;
        let indexOffset = 0;
        if (this.props.headersClickable) {
          indexOffset = 1;
        }

        const extraChildren = [];
        if (this.props.headersClickable) {
          const passdownItem = Object.assign({}, item, { options: null, optionStyle: { fontWeight: 'bold', paddingLeft: 0 } });
          const headerOption = parseOptions(acc, passdownItem, `${itemIndex}-${0}`);
          if (headerOption) {
            extraChildren.push(headerOption);
          }
        }

        let children = items.map((child, i) => parseOptions(acc, child, `${itemIndex}-${i + indexOffset}`)).filter(Boolean);

        children = extraChildren.concat(children);

        return {
          type: 'group',
          key: `${this.getElementId('group')}-${itemIndex}`,
          data: item,
          options: children
        };
      } else {
        const option = toOption(item, `${itemIndex}`);
        if (option && !option.isDisabled) acc.focusable.push(item);
        return option;
      }
    };

    return options.reduce((acc, item, itemIndex) => {
      if (item.options) {
        // TODO needs a tidier implementation
        if (!this.hasGroups) this.hasGroups = true;

        let indexOffset = 0;
        if (this.props.headersClickable) {
          indexOffset = 1;
        }

        const extraChildren = [];
        if (this.props.headersClickable) {
          const passdownItem = Object.assign({}, item, { options: null, optionStyle: { fontWeight: 'bold', paddingLeft: 0 } });
          const headerOption = parseOptions(acc, passdownItem, `${itemIndex}-${0}`);
          if (headerOption) {
            extraChildren.push(headerOption);
          }
        }

        const { options: items } = item;
        let children = items.map((child, i) => parseOptions(acc, child, `${itemIndex}-${i + indexOffset}`)).filter(Boolean);

        children = extraChildren.concat(children);

        if (children.length) {
          const groupId = `${this.getElementId('group')}-${itemIndex}`;
          acc.render.push({
            type: 'group',
            key: groupId,
            data: item,
            options: children
          });
        }
      } else {
        const option = toOption(item, `${itemIndex}`);
        if (option) {
          acc.render.push(option);
          if (!option.isDisabled) acc.focusable.push(item);
        }
      }
      return acc;
    }, { render: [], focusable: [] });
  }

  // ==============================
  // Renderers
  // ==============================
  constructAriaLiveMessage() {
    const {
      ariaLiveContext,
      selectValue,
      focusedValue,
      focusedOption
    } = this.state;
    const { options, menuIsOpen, inputValue, screenReaderStatus } = this.props;

    // An aria live message representing the currently focused value in the select.
    const focusedValueMsg = focusedValue ? (0, _index2.valueFocusAriaMessage)({
      focusedValue,
      getOptionLabel: this.getOptionLabel,
      selectValue
    }) : '';
    // An aria live message representing the currently focused option in the select.
    const focusedOptionMsg = focusedOption && menuIsOpen ? (0, _index2.optionFocusAriaMessage)({
      focusedOption,
      getOptionLabel: this.getOptionLabel,
      options
    }) : '';
    // An aria live message representing the set of focusable results and current searchterm/inputvalue.
    const resultsMsg = (0, _index2.resultsAriaMessage)({
      inputValue,
      screenReaderMessage: screenReaderStatus({ count: this.countOptions() })
    });

    return `${focusedValueMsg} ${focusedOptionMsg} ${resultsMsg} ${ariaLiveContext}`;
  }

  renderInput() {
    const {
      isDisabled,
      isSearchable,
      inputId,
      inputValue,
      tabIndex
    } = this.props;
    const { Input } = this.components;
    const { inputIsHidden } = this.state;

    const id = inputId || this.getElementId('input');

    if (!isSearchable) {
      // use a dummy input to maintain focus/blur functionality
      return _react2.default.createElement(_index.DummyInput, {
        id: id,
        innerRef: this.getInputRef,
        onBlur: this.onInputBlur,
        onChange: _utils.noop,
        onFocus: this.onInputFocus,
        readOnly: true,
        tabIndex: tabIndex,
        value: ''
      });
    }

    // aria attributes makes the JSX "noisy", separated for clarity
    const ariaAttributes = {
      'aria-autocomplete': 'list',
      'aria-label': this.props['aria-label'],
      'aria-labelledby': this.props['aria-labelledby']
    };

    const { cx, theme } = this.commonProps;

    return _react2.default.createElement(Input, _extends({
      autoCapitalize: 'none',
      autoComplete: 'off',
      autoCorrect: 'off',
      cx: cx,
      getStyles: this.getStyles,
      id: id,
      innerRef: this.getInputRef,
      isDisabled: isDisabled,
      isHidden: inputIsHidden,
      onBlur: this.onInputBlur,
      onChange: this.handleInputChange,
      onFocus: this.onInputFocus,
      spellCheck: 'false',
      tabIndex: tabIndex,
      theme: theme,
      type: 'text',
      value: inputValue
    }, ariaAttributes));
  }
  renderPlaceholderOrValue() {
    const {
      MultiValue,
      MultiValueContainer,
      MultiValueLabel,
      MultiValueRemove,
      SingleValue,
      Placeholder
    } = this.components;
    const { commonProps } = this;
    const {
      controlShouldRenderValue,
      isDisabled,
      isMulti,
      inputValue,
      placeholder
    } = this.props;
    const { selectValue, focusedValue } = this.state;

    if (!this.hasValue() || !controlShouldRenderValue) {
      return inputValue ? null : _react2.default.createElement(
        Placeholder,
        _extends({}, commonProps, { key: 'placeholder', isDisabled: isDisabled }),
        placeholder
      );
    }

    if (isMulti) {
      const selectValues = selectValue.map(opt => {
        let isFocused = opt === focusedValue;
        return _react2.default.createElement(
          MultiValue,
          _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isFocused,
            isDisabled: isDisabled,
            key: this.getOptionValue(opt),
            removeProps: {
              onClick: () => this.removeValue(opt),
              onTouchEnd: () => this.removeValue(opt),
              onMouseDown: e => {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }),
          this.formatOptionLabel(opt, 'value')
        );
      });
      return selectValues;
    }

    if (inputValue) {
      return null;
    }

    const singleValue = selectValue[0];
    return _react2.default.createElement(
      SingleValue,
      _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
      this.formatOptionLabel(singleValue, 'value')
    );
  }
  renderClearIndicator() {
    const { ClearIndicator } = this.components;
    const { commonProps } = this;
    const { isDisabled, isLoading } = this.props;
    const { isFocused } = this.state;

    if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
      return null;
    }

    const innerProps = {
      onMouseDown: this.onClearIndicatorMouseDown,
      onTouchEnd: this.onClearIndicatorTouchEnd,
      'aria-hidden': 'true'
    };

    return _react2.default.createElement(ClearIndicator, _extends({}, commonProps, {
      innerProps: innerProps,
      isFocused: isFocused
    }));
  }
  renderLoadingIndicator() {
    const { LoadingIndicator } = this.components;
    const { commonProps } = this;
    const { isDisabled, isLoading } = this.props;
    const { isFocused } = this.state;

    if (!LoadingIndicator || !isLoading) return null;

    const innerProps = { 'aria-hidden': 'true' };
    return _react2.default.createElement(LoadingIndicator, _extends({}, commonProps, {
      innerProps: innerProps,
      isDisabled: isDisabled,
      isFocused: isFocused
    }));
  }
  renderIndicatorSeparator() {
    const { DropdownIndicator, IndicatorSeparator } = this.components;

    // separator doesn't make sense without the dropdown indicator
    if (!DropdownIndicator || !IndicatorSeparator) return null;

    const { commonProps } = this;
    const { isDisabled } = this.props;
    const { isFocused } = this.state;

    return _react2.default.createElement(IndicatorSeparator, _extends({}, commonProps, {
      isDisabled: isDisabled,
      isFocused: isFocused
    }));
  }
  renderDropdownIndicator() {
    const { DropdownIndicator } = this.components;
    if (!DropdownIndicator) return null;
    const { commonProps } = this;
    const { isDisabled } = this.props;
    const { isFocused } = this.state;

    const innerProps = {
      onMouseDown: this.onDropdownIndicatorMouseDown,
      onTouchEnd: this.onDropdownIndicatorTouchEnd,
      'aria-hidden': 'true'
    };

    return _react2.default.createElement(DropdownIndicator, _extends({}, commonProps, {
      innerProps: innerProps,
      isDisabled: isDisabled,
      isFocused: isFocused
    }));
  }
  renderMenu() {
    const {
      Group,
      GroupHeading,
      Menu,
      MenuList,
      MenuPortal,
      LoadingMessage,
      NoOptionsMessage,
      Option
    } = this.components;
    const { commonProps } = this;
    const { focusedOption, menuOptions } = this.state;
    const {
      captureMenuScroll,
      inputValue,
      isLoading,
      loadingMessage,
      minMenuHeight,
      maxMenuHeight,
      menuIsOpen,
      menuPlacement,
      menuPosition,
      menuPortalTarget,
      menuShouldBlockScroll,
      menuShouldScrollIntoView,
      noOptionsMessage,
      onMenuScrollToTop,
      onMenuScrollToBottom
    } = this.props;

    if (!menuIsOpen) return null;

    // TODO: Internal Option Type here
    const render = props => {
      // for performance, the menu options in state aren't changed when the
      // focused option changes so we calculate additional props based on that
      const isFocused = focusedOption === props.data;
      props.innerRef = isFocused ? this.getFocusedOptionRef : undefined;

      return _react2.default.createElement(
        Option,
        _extends({}, commonProps, props, { isFocused: isFocused }),
        this.formatOptionLabel(props.data, 'menu')
      );
    };

    const renderGroup = props => {
      const { type } = props,
            group = _objectWithoutProperties(props, ['type']);
      const headingId = `${props.key}-heading`;
      return _react2.default.createElement(
        Group,
        _extends({}, commonProps, group, {
          Heading: GroupHeading,
          innerProps: {
            'aria-expanded': true,
            'aria-labelledby': headingId,
            role: 'group'
          },
          headingProps: {
            id: headingId
          },
          label: this.formatGroupLabel(props.data)
        }),
        props.options.map(option => option.type === 'group' ? renderGroup(option) : render(option))
      );
    };

    let menuUI;

    if (this.hasOptions()) {
      menuUI = menuOptions.render.map(item => {
        if (item.type === 'group') {
          return renderGroup(item);
        } else if (item.type === 'option') {
          return render(item);
        }
      });
    } else if (isLoading) {
      const message = loadingMessage({ inputValue });
      if (message === null) return null;
      menuUI = _react2.default.createElement(
        LoadingMessage,
        commonProps,
        message
      );
    } else {
      const message = noOptionsMessage({ inputValue });
      if (message === null) return null;
      menuUI = _react2.default.createElement(
        NoOptionsMessage,
        commonProps,
        message
      );
    }
    const menuPlacementProps = {
      minMenuHeight,
      maxMenuHeight,
      menuPlacement,
      menuPosition,
      menuShouldScrollIntoView
    };

    const menuElement = _react2.default.createElement(
      _Menu.MenuPlacer,
      _extends({}, commonProps, menuPlacementProps),
      ({ ref, placerProps: { placement, maxHeight } }) => _react2.default.createElement(
        Menu,
        _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: this.onMenuMouseDown,
            onMouseMove: this.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }),
        _react2.default.createElement(
          _index.ScrollCaptor,
          {
            isEnabled: captureMenuScroll,
            onTopArrive: onMenuScrollToTop,
            onBottomArrive: onMenuScrollToBottom
          },
          _react2.default.createElement(
            _index.ScrollBlock,
            { isEnabled: menuShouldBlockScroll },
            _react2.default.createElement(
              MenuList,
              _extends({}, commonProps, {
                innerRef: this.getMenuListRef,
                isLoading: isLoading,
                maxHeight: maxHeight
              }),
              menuUI
            )
          )
        )
      )
    );

    // positioning behaviour is almost identical for portalled and fixed,
    // so we use the same component. the actual portalling logic is forked
    // within the component based on `menuPosition`
    return menuPortalTarget || menuPosition === 'fixed' ? _react2.default.createElement(
      MenuPortal,
      _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }),
      menuElement
    ) : menuElement;
  }
  renderFormField() {
    const { delimiter, isDisabled, isMulti, name } = this.props;
    const { selectValue } = this.state;

    if (!name || isDisabled) return;

    if (isMulti) {
      if (delimiter) {
        const value = selectValue.map(opt => this.getOptionValue(opt)).join(delimiter);
        return _react2.default.createElement('input', { name: name, type: 'hidden', value: value });
      } else {
        const input = selectValue.length > 0 ? selectValue.map((opt, i) => _react2.default.createElement('input', {
          key: `i-${i}`,
          name: name,
          type: 'hidden',
          value: this.getOptionValue(opt)
        })) : _react2.default.createElement('input', { name: name, type: 'hidden' });

        return _react2.default.createElement(
          'div',
          null,
          input
        );
      }
    } else {
      const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
      return _react2.default.createElement('input', { name: name, type: 'hidden', value: value });
    }
  }

  renderLiveRegion() {
    if (!this.state.isFocused) return null;
    return _react2.default.createElement(
      _index.A11yText,
      { 'aria-live': 'assertive' },
      _react2.default.createElement(
        'p',
        { id: 'aria-selection-event' },
        '\xA0',
        this.state.ariaLiveSelection
      ),
      _react2.default.createElement(
        'p',
        { id: 'aria-context' },
        '\xA0',
        this.constructAriaLiveMessage()
      )
    );
  }

  render() {
    const {
      Control,
      IndicatorsContainer,
      SelectContainer,
      ValueContainer
    } = this.components;

    const { className, id, isDisabled } = this.props;
    const { isFocused } = this.state;

    const commonProps = this.commonProps = this.getCommonProps();

    return _react2.default.createElement(
      SelectContainer,
      _extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }),
      this.renderLiveRegion(),
      _react2.default.createElement(
        Control,
        _extends({}, commonProps, {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        _react2.default.createElement(
          ValueContainer,
          _extends({}, commonProps, { isDisabled: isDisabled }),
          this.renderPlaceholderOrValue(),
          this.renderInput()
        ),
        _react2.default.createElement(
          IndicatorsContainer,
          _extends({}, commonProps, { isDisabled: isDisabled }),
          this.renderClearIndicator(),
          this.renderLoadingIndicator(),
          this.renderIndicatorSeparator(),
          this.renderDropdownIndicator()
        )
      ),
      this.renderMenu(),
      this.renderFormField()
    );
  }
}
exports.default = Select;
Select.defaultProps = defaultProps;

var _initialiseProps = function () {
  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    isComposing: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = ref => {
    this.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = ref => {
    this.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = ref => {
    this.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = ref => {
    this.inputRef = ref;
  };

  this.cacheComponents = components => {
    this.components = (0, _index3.defaultComponents)({ components });
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.setValue = (newValue, action = 'set-value', option) => {
    const { closeMenuOnSelect, isMulti, onChange } = this.props;
    this.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      this.inputIsHiddenAfterUpdate = !isMulti;
      this.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    this.clearFocusValueOnUpdate = true;
    onChange(newValue, { action, option });
  };

  this.selectOption = newValue => {
    const { blurInputOnSelect, isMulti } = this.props;

    if (isMulti) {
      const { selectValue } = this.state;
      if (this.isOptionSelected(newValue, selectValue)) {
        const candidate = this.getOptionValue(newValue);
        this.setValue(selectValue.filter(i => this.getOptionValue(i) !== candidate), 'deselect-option', newValue);
        this.announceAriaLiveSelection({
          event: 'deselect-option',
          context: { value: this.getOptionLabel(newValue) }
        });
      } else {
        this.setValue([...selectValue, newValue], 'select-option', newValue);
        this.announceAriaLiveSelection({
          event: 'select-option',
          context: { value: this.getOptionLabel(newValue) }
        });
      }
    } else {
      this.setValue(newValue, 'select-option');
      this.announceAriaLiveSelection({
        event: 'select-option',
        context: { value: this.getOptionLabel(newValue) }
      });
    }

    if (blurInputOnSelect) {
      this.blurInput();
    }
  };

  this.removeValue = removedValue => {
    const { onChange } = this.props;
    const { selectValue } = this.state;
    const candidate = this.getOptionValue(removedValue);
    onChange(selectValue.filter(i => this.getOptionValue(i) !== candidate), {
      action: 'remove-value',
      removedValue
    });
    this.announceAriaLiveSelection({
      event: 'remove-value',
      context: {
        value: removedValue ? this.getOptionLabel(removedValue) : undefined
      }
    });
    this.focusInput();
  };

  this.clearValue = () => {
    const { isMulti, onChange } = this.props;
    onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = () => {
    const { onChange } = this.props;
    const { selectValue } = this.state;
    const lastSelectedValue = selectValue[selectValue.length - 1];
    this.announceAriaLiveSelection({
      event: 'pop-value',
      context: {
        value: lastSelectedValue ? this.getOptionLabel(lastSelectedValue) : undefined
      }
    });
    onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = data => {
    return this.props.getOptionLabel(data);
  };

  this.getOptionValue = data => {
    return this.props.getOptionValue(data);
  };

  this.getStyles = (key, props) => {
    const base = _styles.defaultStyles[key](props);
    base.boxSizing = 'border-box';
    const custom = this.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = element => {
    return `${this.instancePrefix}-${element}`;
  };

  this.getActiveDescendentId = () => {
    const { menuIsOpen } = this.props;
    const { menuOptions, focusedOption } = this.state;

    if (!focusedOption || !menuIsOpen) return undefined;

    const index = menuOptions.focusable.indexOf(focusedOption);
    const option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = ({
    event,
    context
  }) => {
    this.setState({
      ariaLiveSelection: (0, _index2.valueEventAriaMessage)(event, context)
    });
  };

  this.announceAriaLiveContext = ({
    event,
    context
  }) => {
    this.setState({
      ariaLiveContext: (0, _index2.instructionsAriaMessage)(event, _extends({}, context, {
        label: this.props['aria-label']
      }))
    });
  };

  this.onMenuMouseDown = event => {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    this.focusInput();
  };

  this.onMenuMouseMove = event => {
    this.blockOptionHover = false;
  };

  this.onControlMouseDown = event => {
    const { openMenuOnClick } = this.props;
    if (!this.state.isFocused) {
      if (openMenuOnClick) {
        this.openAfterFocus = true;
      }
      this.focusInput();
    } else if (!this.props.menuIsOpen) {
      this.openMenu('first');
    } else {
      this.onMenuClose();
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = event => {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (this.props.isDisabled) return;
    const { isMulti, menuIsOpen } = this.props;
    this.focusInput();
    if (menuIsOpen) {
      this.inputIsHiddenAfterUpdate = !isMulti;
      this.onMenuClose();
    } else {
      this.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = event => {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    this.clearValue();
    event.stopPropagation();
    this.openAfterFocus = false;
    setTimeout(() => this.focusInput());
  };

  this.onScroll = event => {
    if (typeof this.props.closeMenuOnScroll === 'boolean') {
      if (event.target instanceof HTMLElement && (0, _utils.isDocumentElement)(event.target)) {
        this.props.onMenuClose();
      }
    } else if (typeof this.props.closeMenuOnScroll === 'function') {
      if (this.props.closeMenuOnScroll(event)) {
        this.props.onMenuClose();
      }
    }
  };

  this.onCompositionStart = () => {
    this.setState({
      isComposing: true
    });
  };

  this.onCompositionEnd = () => {
    this.setState({
      isComposing: false
    });
  };

  this.onTouchStart = ({ touches: [touch] }) => {
    this.initialTouchX = touch.clientX;
    this.initialTouchY = touch.clientY;
    this.userIsDragging = false;
  };

  this.onTouchMove = ({ touches: [touch] }) => {
    const deltaX = Math.abs(touch.clientX - this.initialTouchX);
    const deltaY = Math.abs(touch.clientY - this.initialTouchY);
    const moveThreshold = 5;

    this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = event => {
    if (this.userIsDragging) return;

    // type cast the EventTarget
    const target = event.target;

    // close the menu if the user taps outside
    if (this.controlRef && !this.controlRef.contains(target) && this.menuListRef && !this.menuListRef.contains(target)) {
      this.blurInput();
    }

    // reset move vars
    this.initialTouchX = 0;
    this.initialTouchY = 0;
  };

  this.onControlTouchEnd = event => {
    if (this.userIsDragging) return;

    this.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = event => {
    if (this.userIsDragging) return;

    this.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = event => {
    if (this.userIsDragging) return;

    this.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = event => {
    const inputValue = event.currentTarget.value;
    this.inputIsHiddenAfterUpdate = false;
    this.onInputChange(inputValue, { action: 'input-change' });
    this.onMenuOpen();
  };

  this.onInputFocus = event => {
    const { isSearchable, isMulti } = this.props;
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
    this.inputIsHiddenAfterUpdate = false;
    this.announceAriaLiveContext({
      event: 'input',
      context: { isSearchable, isMulti }
    });
    this.setState({
      isFocused: true
    });
    if (this.openAfterFocus || this.props.openMenuOnFocus) {
      this.openMenu('first');
    }
    this.openAfterFocus = false;
  };

  this.onInputBlur = event => {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
    this.onInputChange('', { action: 'input-blur' });
    this.onMenuClose();
    this.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = focusedOption => {
    if (this.blockOptionHover || this.state.focusedOption === focusedOption) {
      return;
    }
    this.setState({ focusedOption });
  };

  this.shouldHideSelectedOptions = () => {
    const { hideSelectedOptions, isMulti } = this.props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = event => {
    const {
      isMulti,
      backspaceRemovesValue,
      escapeClearsValue,
      inputValue,
      isClearable,
      isDisabled,
      menuIsOpen,
      onKeyDown,
      tabSelectsValue,
      openMenuOnFocus
    } = this.props;
    const {
      isComposing,
      focusedOption,
      focusedValue,
      selectValue
    } = this.state;

    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    this.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        this.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        this.focusValue('next');
        break;
      case 'Delete':
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          this.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          this.popValue();
        }
        break;
      case 'Tab':
        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        this.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          if (isComposing) return;
          this.selectOption(focusedOption);
        } else {
          this.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          this.inputIsHiddenAfterUpdate = false;
          this.onInputChange('', { action: 'menu-close' });
          this.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          this.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          this.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        this.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          this.focusOption('up');
        } else {
          this.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          this.focusOption('down');
        } else {
          this.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        this.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        this.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        this.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        this.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};